module.exports = __webpack_public_path__ + "img/dispatchingWorkersHeader.0e14be09.png";